import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)


const store = new Vuex.Store({
  state: {
    phone:'400-188-9318', // 初始化一个状态，存放公共电话
    QQ:'',// 初始化一个状态，存放公共QQ号码
    screenWidth:document.documentElement.clientWidth, //屏幕宽度
    isShow:false //控制H5导航栏
  },
  mutations: {
    SET_PHONE: (state, phone) => {
      state.phone = phone
    },
    SET_qq: (state, qq) => {
      console.log(123)
      state.qq = qq
    },
    SET_ISSHOW:(state,isShow)=>{
      state.isShow=isShow
    }
  }
})

export default store


// WEBPACK FOOTER //
// ./src/store/index.js